import { useUser } from "@clerk/clerk-react";

import { isLocalLabAuthMode } from "../lib/auth-mode.js";

import type { Role } from "@l30/shared";

/**
 * Read the current user's role from Clerk public metadata.
 * Mirrors the API auth middleware: missing role defaults to "client".
 */
export function useCurrentRole(): Role {
  if (isLocalLabAuthMode) {
    return "admin";
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- VITE_AUTH_MODE is build-time stable; local lab omits ClerkProvider.
  return useClerkCurrentRole();
}

function useClerkCurrentRole(): Role {
  const { user } = useUser();
  const role = user?.publicMetadata?.["role"];
  return (typeof role === "string" ? role : "client") as Role;
}

export function useIsAdmin(): boolean {
  return useCurrentRole() === "admin";
}

export function useCurrentUserEmail(): string {
  if (isLocalLabAuthMode) {
    return import.meta.env.VITE_LAB_STAFF_EMAIL ?? "martyn@latitude30.co";
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- VITE_AUTH_MODE is build-time stable; local lab omits ClerkProvider.
  return useClerkCurrentUserEmail();
}

function useClerkCurrentUserEmail(): string {
  const { user } = useUser();
  return user?.primaryEmailAddress?.emailAddress ?? user?.emailAddresses?.[0]?.emailAddress ?? "";
}
